import { create } from "zustand"
import { devtools, persist } from "zustand/middleware"
import { autoDetectBrowserLang } from "@/shared/utils"

interface Store {
  lang: string
  setLang: (lang: string) => void
}

// Check if this is the first time the store is being initialized
const getInitialLanguage = (): string => {
  // Check if there's already a persisted value in localStorage
  const persistedData = localStorage.getItem("localization-store")

  if (persistedData) {
    try {
      const parsed = JSON.parse(persistedData)
      if (parsed.state && parsed.state.lang) {
        // User already has a language preference, use it
        return parsed.state.lang
      }
    } catch (error) {
      console.warn("Failed to parse persisted language data:", error)
    }
  }

  // No persisted language found, use auto-detection
  const detectedLang = autoDetectBrowserLang()
  return detectedLang
}

export const useLangStore = create<Store>()(
  devtools(
    persist(
      set => ({
        lang: getInitialLanguage(),
        setLang: (lang: string) => set({ lang }),
      }),
      {
        name: "localization-store",
      }
    ),
    { name: "LangStore", enabled: process.env.NODE_ENV === "development" }
  )
)
